import httpRequest from 'httpRequest'
import { UOMContract } from 'models'
import { UOMClassContract } from 'models/UOMClassContract'

const UOM_PREFIX = '/uoms'

const uomService = {
    getAllUOMs() {
        return httpRequest.get<UOMContract[]>(UOM_PREFIX)
    },

    getUOMByID(id: number) {
        return httpRequest.get<UOMContract>(UOM_PREFIX + '/' + id)
    },

    getUOMClasses() {
        return httpRequest.get<UOMClassContract[]>(UOM_PREFIX + '/classes')
    },

    createCustomUOM(payload: UOMContract) {
        return httpRequest.post<UOMContract>(UOM_PREFIX, payload)
    },

    updateCustomUOM(id: number, payload: UOMContract) {
        return httpRequest.put<UOMContract>(UOM_PREFIX + '/' + id, payload)
    },

    updateDefaultUOM(id: number) {
        return httpRequest.put(UOM_PREFIX + `/default-uom/${id}`)
    },
    /**
     * @param ids
     * @returns List of unremovable uom ids
     */
    removeCustomUOMs(ids: number[]) {
        return httpRequest.delete<number[]>(UOM_PREFIX, {
            params: { ids },
        })
    },
}

export default uomService
